import type { ListGroupProps } from './ListGroup.type';
import * as Styled from './ListGroup.styled';

const ListGroup = (props: ListGroupProps) => {
  const { children, ...rest } = props;
  return (
    <Styled.Group {...rest}>
      <Styled.Title>{children}</Styled.Title>
    </Styled.Group>
  );
};

export default ListGroup;
